var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-crud',_vm._b({},'entity-crud',{ model: _vm.model, title: _vm.title, tableColumns: _vm.tableColumns, formColumns: _vm.formColumns, formStyleVariant: _vm.formStyleVariant },false))}
var staticRenderFns = []

export { render, staticRenderFns }